import { useState } from "react";
import { useSettings } from "../settings/context";

/**
 * TRANSLATE EVERYTHING — one press for the whole site.
 *
 * Filling forty settings one button at a time is not a workflow, it is a chore.
 * This walks every screen's translatable settings and fills the languages that
 * are still silent.
 *
 * ⚠️ ONLY FROM THE REFERENCE LANGUAGE. The route fills every target from what it
 * is given, so from any other the source would itself be a translation — and the
 * reference would be among the things overwritten.
 *
 * ⚠️ NO CONFIRMATION MESSAGE, deliberately. The count IS the report: it goes to
 * zero and the button leaves. If something failed, the button simply stays with
 * what is left — which says more than "2 en échec" ever did, because it also
 * says how to finish. A badge announcing success would be one more thing to read
 * in a row that is already tight.
 *
 * Displayed strings are French: the organiser is a French speaker.
 */
export function TranslateAll() {
  const { toTranslate, translateAll, scope, saving, translating } =
    useSettings();
  const [busy, setBusy] = useState(false);

  const pending = saving ? toTranslate() : 0;
  const offered =
    saving &&
    scope.languageId === scope.defaultLanguageId &&
    (pending > 0 || busy);
  if (!offered) return null;

  return (
    <button
      type="button"
      className="obtn"
      data-missing={pending > 0 ? "1" : undefined}
      disabled={busy || translating !== null}
      title={`Remplir les langues manquantes de ${pending} réglage${pending > 1 ? "s" : ""}, sur tous les écrans`}
      onClick={async () => {
        setBusy(true);
        try {
          await translateAll();
        } finally {
          setBusy(false);
        }
      }}
    >
      {busy ? (
        <>
          <span className="spin" aria-hidden="true" />
          Traduction
        </>
      ) : (
        `Tout traduire (${pending})`
      )}
    </button>
  );
}
